import * as React from 'react'
import {
  Action,
  any,
  async,
  fromJSX,
  nothing,
  stateful
} from 'widgets-for-react'
import {
  PostRefundResponse,
  RefundingSpecification,
  RemoveEscrowResponse
} from './bookingDetailsApi'

import { BookingLayout } from './bookingDetailsLayout'
import {
  Booking,
  bookingDetailsUpdaters,
  initialState,
  Props,
  State
} from './bookingDetailsState'

export const root = (props: Props) =>
  stateful<State>({ key: 'booking-details' })(s0 =>
    any<Action<State>>()([
      s0.kind === 'loading'
        ? async<Booking>()(s0.booking).map(a =>
            bookingDetailsUpdaters.onBookingUpdate(a)
          )
        : nothing(),
      s0.kind === 'loaded' && s0.refunding.v.kind === 'r'
        ? any<Action<State>>()([
            async<RefundingSpecification>()(
              s0.refunding.v.v.specification
            ).map(a =>
              bookingDetailsUpdaters.onRefundingSpecificationUpdate(a)
            ),
            async<PostRefundResponse>()(s0.refunding.v.v.refunding).map(a =>
              bookingDetailsUpdaters.onPostRefundingUpdate(a)
            ),
            async<RemoveEscrowResponse>()(
              s0.refunding.v.v.removeEscrow
            ).map(a => bookingDetailsUpdaters.onRemoveEscrowUpdate(a))
          ])
        : nothing(),
      fromJSX(setState => (
        <BookingLayout
          state={s0}
          loading_gif={props.loading_gif}
          toggleDetailedRentalAmount={() =>
            setState(bookingDetailsUpdaters.onToggleDetailedRentalAmount())
          }
          onRefundAmountChange={x => {
            setState(bookingDetailsUpdaters.onRefundAmountChange(x))
          }}
          onRefundSubmit={() => {
            setState(bookingDetailsUpdaters.onRefundSubmit())
          }}
          onRemoveEscrow={t => {
            setState(bookingDetailsUpdaters.onRemoveEscrow(t))
          }}
        />
      ))
    ]).map(a => a(s0))
  )(initialState(props))
